import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationSection from './ConfirmationSection';

// The page asks "Do you have a bank account?" with yesNoReverse, so a stored
// directDeposit.hasNoAccount of false means the Veteran answered "Yes".
const ConfirmationDirectDeposit = ({ formData }) => {
  const hasNoAccount = formData?.directDeposit?.hasNoAccount;
  if (typeof hasNoAccount !== 'boolean') return null;

  return (
    <ConfirmationSection
      title="Direct deposit"
      rows={[
        {
          label: 'Do you have a bank account for direct deposit?',
          value: hasNoAccount ? 'No' : 'Yes',
        },
      ]}
    />
  );
};

ConfirmationDirectDeposit.propTypes = {
  formData: PropTypes.shape({
    directDeposit: PropTypes.shape({
      hasNoAccount: PropTypes.bool,
    }),
  }),
};

export default ConfirmationDirectDeposit;
